// @flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withTheme } from 'styled-components';
import classnames from 'classnames';
import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar';
import MenuIcon from 'material-ui/svg-icons/navigation/menu';
import { Logo } from 'common/layout/styles';
import Radio from 'common/domain/radio';
import NotificationsPanel from 'common/modules/ui/components/NotificationsPanel';
import { Images } from '../themes';
import ProfileDropDown from '../modules/userProfile/components/ProfileDropDown';

interface Props {
  switchRadio: (radio: Radio) => mixed;
  notificationRenderers: Object;
  forceMenuDisplay: boolean;
  onMenuIconClick: () => void;
  theme: any;
  history: any;
}

function NavBar({ switchRadio, notificationRenderers, forceMenuDisplay, onMenuIconClick, theme, history }: Props) {
  return (
    <Toolbar
      className={classnames('app-bar', { extended: forceMenuDisplay })}
      style={{
        height: 64,
        backgroundColor: theme.colors.primary,
        color: theme.colors.tertiaryText,
        boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 10px, rgba(0, 0, 0, 0.23) 0px 3px 10px',
        zIndex: 1200,
      }}
    >
      <ToolbarGroup>
        {!forceMenuDisplay &&
        <MenuIcon onClick={onMenuIconClick} style={{ marginRight: 24, color: 'inherit' }} />
        }
        <Logo src={Images.logoWhite} alt="logo" onClick={() => history.push('/')} style={{ cursor: 'pointer', margin: 'auto' }} />
      </ToolbarGroup>
      <ToolbarGroup>
        <NotificationsPanel switchRadio={switchRadio} notificationRenderers={notificationRenderers} />
        <ProfileDropDown />
      </ToolbarGroup>
    </Toolbar>
  );
}

export default withRouter(withTheme(NavBar));



// WEBPACK FOOTER //
// ./src/statsradio/layout/NavBar.js